export type AuthCheckStatus =
  | "authenticated"
  | "unauthenticated"
  | "unavailable";

export type ProtectedRouteAuthDecision =
  | "allow"
  | "session-expired"
  | "sign-in";

export function getProtectedRouteAuthDecision(
  authStatus: AuthCheckStatus,
  hadStoredUser: boolean,
): ProtectedRouteAuthDecision {
  if (authStatus === "authenticated") {
    return "allow";
  }

  if (authStatus === "unavailable") {
    return hadStoredUser ? "allow" : "sign-in";
  }

  return hadStoredUser ? "session-expired" : "sign-in";
}
